<template>
  <el-dialog
    title="储值卡入库"
    :visible.sync="show"
    width="60%"
    :before-close="handleCloseFun">
    <div class="content">
      <div class="filter">
        <span>扫码入库：</span>
        <el-input ref="input" v-model.trim="cardNo" placeholder="" size="small" @keyup.native.enter="tapFun"></el-input>
        <span>扫描数量：<span style="color: red">{{ pager.count }}</span> 张</span>
      </div>
      <div class="action_box">
        <el-button type="primary" size="small" @click="handleCloseFun">完成入库</el-button>
      </div>
      <Table :TableParam="Table">
        <template v-slot:cardNature="{ item }">
          <span>{{ $label.getLabel($label.CardTypes, item.cardNature) }}</span>
        </template>
        <template v-slot:Paging>
          <Paging @change="getItemList" :pager="pager" />
        </template>
      </Table>
    </div>
  </el-dialog>
</template>

<script>
import Table from "@/components/Table";
import Paging from "@/components/Paging";
export default {
  name: "Modal",
  components: {
    Table,
    Paging,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cardNo: '',
      inboundSn: '',
      pager: {
        page: 1,
        rows: 10,
        count: 0
      },
      Table: {
        isHeader: false,
        data: [],
        column: [
          { prop: 'cardNature', label: '卡种类', slot: true },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'cardNo', label: '卡号' },
          { prop: 'remaining', label: '余额' },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'denomination', label: '面值(元)' },
          { prop: 'validPeriod', label: '有效期' },
          { prop: 'stateText', label: '状态' },
          { prop: 'inboundTime', label: '入库日期' },
        ]
      }
    };
  },
  created () {
    this.createInboundSn()
  },
  methods: {
    getItemList () {
      const { pager, Table, inboundSn } = this
      const data = {
        inboundSn,
        pageNum: pager.page,
        pageSize: pager.rows
      }
      this.$http.getStoreCardListApi(data).then(res => {
        pager.count = res?.data?.total || 0
        Table.data = (res?.data?.list || []).map((item) => ({
            ...item,
            stateText: item.state.text,
          }))
      })
    },
    handleCloseFun() {
      this.$emit('getList')
      this.$emit("update:show", false);
    },
    // 生成批次号
    createInboundSn () {
      this.$http.createInboundSnApi().then(res => {
        this.inboundSn = res.data || ''
      })
    },
    tapFun () {
      if(!this.cardNo || !this.inboundSn) return
      const data = {
        cardNo: this.cardNo,
        inboundSn: this.inboundSn
      }
      this.$http.inboundCardApi(data).then(({ status, msg }) => {
        if(status === 200) {
          this.cardNo = ''
          this.getItemList()
          this.$message.success(msg)
        }
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.input && this.$refs.input.focus()
    })
  }
};
</script>

<style lang="scss" scoped>
.filter {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin: 0 10px;
    flex-shrink: 0;
  }
  .el-input {
    max-width: 600px;
  }
}
.action_box {
    margin: 20px 0;
    text-align: right;
}
</style>